const getKeyOfValue = (val, obj) => {
  for (let each in obj) {
    if (obj[each] === val) {
      return each;
    }
  }
};

export default getKeyOfValue;
